// Single source of truth for "this route must never show ads (or be indexed as a
// customer-portal/private page)" — used by AdSlot's own defensive check (§27/§80) and
// by robotsPolicy.js's noindex logic conceptually mirrors this list (kept separately
// there since SEO and ad-safety are different concerns that happen to overlap heavily,
// not because the underlying judgment differs).
//
// This is deliberately a PREFIX list, not a route-by-route enumeration — every current
// and future admin/account/billing page is covered automatically without needing to
// remember to add each new page here individually.
export const SENSITIVE_ROUTE_PREFIXES = [
  "/admin", // admin console: dashboard, sites, sales, onboarding, finance, BIR/tax, reviews, contacts
  "/account", // customer portal: login, dashboard, per-website billing/invoices/subscription
  "/billing", // PayMongo checkout return pages (success/cancelled) — payment-adjacent
  "/checkout", // authenticated payment details
  "/ph/checkout", // Philippines payment details
  "/qa", // isolated test websites; never index or advertise
];

export function isSensitiveRoute(pathname) {
  const normalized = (pathname || "").toLowerCase().replace(/\/$/, "") || "/";
  return SENSITIVE_ROUTE_PREFIXES.some((prefix) => normalized === prefix || normalized.startsWith(`${prefix}/`));
}
